(() => {
  document.querySelectorAll('.hip-explorer').forEach(explorer => {
    if (explorer.dataset.ready) return;
    explorer.dataset.ready = 'true';
    const details = [...explorer.querySelectorAll('.hip-ingredient')];
    const spots = [...explorer.querySelectorAll('[data-ingredient-spot]')];
    const setActiveIngredient = (key, replay = false) => {
      spots.forEach(spot => {
        const keys = spot.dataset.ingredientSpot.split(' ');
        const isMatch = Boolean(key && keys.includes(key));
        if (!isMatch) {
          spot.classList.remove('is-active');
          return;
        }
        if (replay && spot.classList.contains('is-active')) {
          spot.classList.remove('is-active');
          void spot.offsetWidth;
        }
        spot.classList.add('is-active');
      });
    };
    const syncActiveIngredient = (replay = false) => {
      const activeDetail = details.find(detail => detail.open);
      setActiveIngredient(activeDetail?.dataset.ingredientKey || '', replay);
    };
    let activeFrame = 0;
    let replayOnSync = false;
    const scheduleActiveIngredient = replay => {
      replayOnSync = replayOnSync || replay;
      if (activeFrame) cancelAnimationFrame(activeFrame);
      activeFrame = requestAnimationFrame(() => {
        syncActiveIngredient(replayOnSync);
        replayOnSync = false;
        activeFrame = 0;
      });
    };
    details.forEach(detail => {
      detail.addEventListener('toggle', () => {
        if (detail.open) details.forEach(other => { if (other !== detail) other.open = false; });
        scheduleActiveIngredient(detail.open);
      });
    });
    syncActiveIngredient();
    const controls = explorer.querySelector('.hip-serving-controls');
    controls.hidden = false;
    controls.addEventListener('click', event => {
      const button = event.target.closest('button[data-serving]');
      if (!button) return;
      const serving = button.dataset.serving;
      controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      explorer.querySelectorAll('.hip-dose').forEach(dose => { dose.textContent = `${dose.dataset[serving]} mg`; });
      explorer.querySelector('.hip-serving-status').textContent = serving === 'daily' ? explorer.dataset.servingDaily : explorer.dataset.servingCapsule;
    });
  });
})();
